import PropTypes from 'prop-types'
import React from 'react'
import focusable from '../../components/Focusable/Focusable'
import FocusableDiv from '../../components/FocusableDiv/FocusableDiv'
import tts from '../../lib/TTS'
import Carousel from '../Carousel/Carousel'
import {
  platformTransitionStyle,
  removeDuplicatesByProperty,
} from '../../../../shared/helpers'
export class CarouselList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.componentType = 'carouselList'
    this.carousels = []
    this.placeholder = null
    this.state = {
      collections: props.collections,
      selectedRow: 0,
      slideOffset: 0,
      resetCarousel: false,
      endingPoint: 4,
    }

    this.carouselOuterList = React.createRef()
    this.placeholderRef = React.createRef()
  }

  componentDidMount() {
    // we need to check what kind of content is in the carousel to determine the default number of items to preload
    const endingPoint =
      this.props.collections[0]?.content[0]?.item_type === 'show' ? 3 : 4
    this.setState({ endingPoint })

    this.carouselListDomNode = this.carouselOuterList.current
    this.carouselListDomNodeStyle = window.getComputedStyle(
      this.carouselListDomNode
    )
    this.carouselListTopOffset = Math.round(
      Number(
        this.carouselListDomNodeStyle
          .getPropertyValue('padding-top')
          .replace('px', '')
      )
    )
  }

  componentDidUpdate(prevProps, prevState) {
    let oldSlideOffset = this.state.slideOffset
    let newSlideOffset = oldSlideOffset
    let oldSelectedRow = this.state.selectedRow
    let newSelectedRow = oldSelectedRow
    if (this.props.collections !== prevProps.collections) {
      for (let i = 0; i < this.props.collections.length; i++) {
        const collection = this.props.collections[i]
        if (collection.slug === 'videoasset-results') {
          newSlideOffset = oldSlideOffset
          newSelectedRow = oldSelectedRow
          break
        } else {
          newSlideOffset = 0
          newSelectedRow = 0
        }
      }
      this.setState({
        collections: this.props.collections,
        selectedRow: newSelectedRow,
        slideOffset: newSlideOffset,
      })
      // empty carousel refs when getting new collections
      this.carousels = []
    }

    if (
      this.state.resetCarousel !== prevState.resetCarousel &&
      this.state.resetCarousel
    ) {
      const firstRow = this.state.selectedRow === 0
      const noOffset = this.state.slideOffset === 0

      if (firstRow && noOffset) {
        this.setState({
          resetCarousel: false,
        })
      }
    }
  }

  onKeyEvent(key) {
    let handled = false
    let selectedRow = this.state.selectedRow

    if ('DOWN' === key) {
      if (selectedRow < this.carousels.length - 1) {
        this.setState((prevState) => {
          let endingPoint = prevState.endingPoint
          if (endingPoint < this.props.collections.length) {
            endingPoint++
          }
          return {
            ...prevState,
            selectedRow: prevState.selectedRow + 1,
            endingPoint,
          }
        })
        this.onNavigation(key)
        handled = true
      }
    } else if ('UP' === key) {
      if (0 < this.state.selectedRow) {
        this.setState((prevState) => {
          return {
            ...prevState,
            selectedRow: prevState.selectedRow - 1,
          }
        })
        this.onNavigation(key)
        handled = true
      } else if (0 === this.state.selectedRow) {
        this.setState({
          resetCarousel: true,
          slideOffset: 0,
        })
        //}
      }
    }

    if ('BACK' === key) {
      this.setState({ selectedRow: 0, slideOffset: 0 })
      this.setState({
        resetCarousel: true,
      })
    }

    return handled
  }

  onNavigation(key = null) {
    let selectedRow = key
      ? key === 'UP'
        ? this.state.selectedRow - 1
        : this.state.selectedRow + 1
      : this.state.selectedRow
    let carousel

    if (this.carousels[selectedRow]?.instance === null) {
      return
    } else {
      carousel = this.carousels[selectedRow]?.instance?.carouselRef?.current
    }

    if (carousel) {
      tts.stopRead()

      const carouselTopOffset = carousel.offsetTop
      let slideOffset = 0 + carouselTopOffset - this.carouselListTopOffset

      if (this.props.disableAutoYScrolling) {
        slideOffset = 0
      }

      this.carousels[selectedRow]?.setFocus()

      this.setState({
        slideOffset,
      })
    } else if (this.placeholder) {
      this.placeholder?.setFocus()
    } else {
      return
    }
  }

  setChildFocus() {
    this.carousels[this.state.selectedRow]?.setFocus()
  }
  setFocusableDivRef(element) {
    this.placeholderRef = element
  }

  setCarouselsRef = (index) => (ref) => {
    if (ref !== null) {
      this.carousels[index] = ref
    }
  }

  render() {
    const {
      slug,
      hideTitle,
      hideMetaData,
      funderMessage,
      collections,
      parentTitle,
      hasSeasons,
      spinnerVisible,
    } = this.props

    const { resetCarousel, endingPoint } = this.state

    return (
      <div
        className="carousel-list-container"
        ref={this.carouselOuterList}
        style={{
          transition: platformTransitionStyle('transform 500ms ease-in-out'),
          transform: `translateY(-${this.state.slideOffset}px)`,
        }}
      >
        {collections && (
          <div>
            {collections.length > 0 ? (
              collections
                .filter(
                  (collection) =>
                    collection.content && 0 !== collection.content.length
                )
                .slice(0, endingPoint)
                .map((collection, index) => (
                  <Carousel
                    key={`${collection.slug}${collection.title.replace(
                      /\s/g,
                      ''
                    )}`}
                    handleNearEndOfCarousel={this.props.handleNearEndOfCarousel}
                    emptySet={collection.content[0]?.empty_set}
                    collection={{
                      ...collection,
                      content: removeDuplicatesByProperty(
                        collection.content,
                        'cid'
                      ),
                    }}
                    listHasSeasons={hasSeasons}
                    hideTitle={hideTitle}
                    hideMetaData={hideMetaData}
                    parent={this}
                    parentTitle={parentTitle}
                    recentlyWatched={
                      0 === index ? this.props.recentlyWatched : null
                    }
                    slug={slug}
                    ref={this.setCarouselsRef(index).bind(this)}
                    resetCarousel={resetCarousel}
                  />
                ))
            ) : spinnerVisible === true ? null : (
              <FocusableDiv
                parent={this}
                id={'focusablePlaceholder'}
                componentType="focusablePlaceholder"
                ref={this.setFocusableDivRef.bind(this)}
              >
                {this.props.emptyMessage &&
                  `There are no videos available right now.`}
              </FocusableDiv>
            )}
            {spinnerVisible === true ? null : funderMessage ? (
              <h4
                className="funder-message"
                dangerouslySetInnerHTML={{ __html: funderMessage }}
              />
            ) : (
              <div className="spacer"></div>
            )}
          </div>
        )}
      </div>
    )
  }
}

CarouselList.propTypes = {
  collections: PropTypes.any,
  disableAutoYScrolling: PropTypes.bool,
  emptyMessage: PropTypes.bool,
  funderMessage: PropTypes.string,
  hasSeasons: PropTypes.object,
  hideMetaData: PropTypes.bool,
  hideTitle: PropTypes.bool,
  parentTitle: PropTypes.string,
  recentlyWatched: PropTypes.object,
  resetCarousel: PropTypes.bool,
  slug: PropTypes.string,
  spinnerVisible: PropTypes.bool,
  handleNearEndOfCarousel: PropTypes.func,
}

export default focusable(CarouselList)
